
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
  FormDescription,
} from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { CreateTechniqueFormValues } from './FormSchema';

interface PostureFieldProps {
  form: UseFormReturn<CreateTechniqueFormValues>;
}

export const PostureField: React.FC<PostureFieldProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="posture"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Posture</FormLabel>
          <Select onValueChange={field.onChange} value={field.value}>
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select a posture" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="offensive">Offensive</SelectItem>
              <SelectItem value="defensive">Defensive</SelectItem>
            </SelectContent>
          </Select>
          <FormDescription>
            Specify the posture of this technique (offensive or defensive)
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
